(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/coupon/team.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/coupon/team.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.views = svs.matchen.views || {};

  svs.matchen.views.Team = Marionette.View.extend({
    options: {
      outcomes: null
    },

    className: 'view-team team align-center',

    regions: {
      outcomes: '.region-outcomes'
    },

    template: function(data) {
      return svs.matchen.templates.team(data);
    },

    onRender: function() {
      if (svs.matchen.tipsInfo.isSvenskaFolketActive()) {
        this.$el.addClass('team-percent');
      } else {
        this.$el.removeClass('team-percent');
      }

      this.showChildView(
        'outcomes',
        new svs.matchen.views.Outcomes({
          collection: this.getOption('outcomes'),
          percentActive: svs.matchen.tipsInfo.isSvenskaFolketActive()
        })
      );
    },

    hide: function() {
      this.$el.hide();
    },

    show: function() {
      this.$el.show();
    }
  });
})(Backbone, _, svs);


 })(window);